import { render, staticRenderFns } from "./DeptMng.vue?vue&type=template&id=73d95d22&"
import script from "./DeptMng.vue?vue&type=script&lang=js&"
export * from "./DeptMng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports